import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import toast from "../services/toast"

export default () => {
    const axiosInstance = axios.create({
        baseURL: `${process.env.VUE_APP_URL}`
    })

    const token = localStorage.getItem('token')
    console.log("1", token)
    if (token) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`
    }

    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            /** user authentication failed */
            const code = error?.response?.status
            switch (code) {
                /** handled server errors */
                case 500:
                    toastify(error.response?.data?.message)
                    break;
                case 401:
                    localStorage.removeItem('token')
                    localStorage.removeItem('user')
                    location.reload()
                    toastify("جلسه کاری شما به پایان رسیده است")
                    break;
                case 403:
                    document.location.href = '/login'
                /** uknonw errors */
                default:
                    toastify("یک خطا رخ داده است لطفا بعدا مجددا تلاش نمایید")
            }
            return Promise.reject(error)
        }
    )
    return axiosInstance
}

/**
 * less code on toast
 * @param {String} message
 * @param {String} icon
 * @returns
 */
function toastify(message, icon = "EditIcon", variant = "error") {
    return toast({
        component: ToastificationContent,
        props: {
            title: message,
            icon,
            variant,
        },
    })
}
